import './styles.scss';

import React from 'react';

import AdminUpgrade from './components/AdminUpgrade';

import { ContextManagerTrial } from './context/contextManagerTrial';

import { Profile, ManagerTrialProps } from './@model/ManagerTrial.model';
import ClientUpgrade from './components/ClientUpgrade';

import usePlan from 'pctHooks/usePlan';

const ManagerTrial = (props: ManagerTrialProps) => {
    const { getActivePlanData } = usePlan();

    return (
        <ContextManagerTrial>
            {props.profile &&
                {
                    [Profile.admin]: <AdminUpgrade modal={props.modal} />,
                    [Profile.client]: getActivePlanData() ? (
                        <ClientUpgrade modal={props.modal} />
                    ) : (
                        <AdminUpgrade modal={props.modal} />
                    ),
                }[props.profile]}
        </ContextManagerTrial>
    );
};

export default ManagerTrial;
